import { useRoutes } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { DocTypeSelect } from './pages/DocTypeOptionsPage';
import { FileUploader } from './pages/FileUploader';
import { UploadComplete } from './pages/UploadComplete';
import { Brands } from './types/types';
import { CreditorDocOptions } from './pages/CreditorOptionsPage';
import { IncomeDocOptions } from './pages/IncomeOptionsPage';
import { OffsetEvidenceOptions } from './pages/OffsetEvidenceOptionsPage';
import { IncomeExpenditureOptions } from './pages/IncomeExpenditureOptionsPage';
import { CarHPDocOptions } from './pages/CarHPDocOptionsPage';
import { PropertyDocOptions } from './pages/PropertyDocOptionsPage';
import { VariationDocOptions } from './pages/VariationDocOptionsPage';
import { OtherDocOptions } from './pages/OtherDocOptionsPage';

const brand = Brands[0];

export const AppRouter = () => {
    let routes = useRoutes([
        {
            path: "/", element: < LandingPage
                brand={brand.title}
                contactUsLink={brand.contactUsLink}
            />
        },
        {
            path: "/file-type",
            element: <DocTypeSelect />
        },
        {
            path: "/creditor-file-type",
            element: <CreditorDocOptions />
        },
        {
            path: "/income-file-type",
            element: <IncomeDocOptions />
        },
        {
            path: "/offset-evidence-file-type",
            element: <OffsetEvidenceOptions />
        },
        {
            path: "/income-expenditure-file-type",
            element: <IncomeExpenditureOptions />
        },
        {
            path: "/car-hp-documents-file-type",
            element: <CarHPDocOptions />
        },
        {
            path: "/property-documents-file-type",
            element: <PropertyDocOptions />
        },
        {
            path: "/variation-file-type",
            element: <VariationDocOptions />
        },
        {
            path: "/others-file-type",
            element: <OtherDocOptions />
        },
        {
            path: "/upload",
            element: <FileUploader />
        },
        {
            path: "/complete",
            element: <UploadComplete />
        }
    ]);
    return routes;
};